/**
 * @generated SignedSource<<4275590ecf668eb892451562fa9143bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MediaType = "PHOTO" | "VIDEO" | "WEB_MUX_VIDEO" | "%future added value";
export type GraphQLHighlightInputPartial = {
  caption?: string | null;
  destinationUrl?: string | null;
  id: string;
  isArchived?: boolean | null;
  isNotifEnabled: boolean;
  mediaType?: MediaType | null;
  mediaUploadable?: any | null;
  muxVideoId?: string | null;
  notifSubtitle?: string | null;
  notifTitle?: string | null;
  notifUtmCampaign?: string | null;
  publishedAt?: any | null;
};
export type HighlightManageFormUpdateMutation$variables = {
  input: GraphQLHighlightInputPartial;
};
export type HighlightManageFormUpdateMutation$data = {
  readonly updateHighlight: {
    readonly archivedAt: any | null;
    readonly caption: string | null;
    readonly destinationUrl: string | null;
    readonly highlightAlbum: {
      readonly archivedCount: number;
      readonly count: number;
      readonly coverImageUrl: string | null;
      readonly id: string;
    };
    readonly id: string;
    readonly media: {
      readonly coverImageUrl: string | null;
      readonly isProcessing: boolean;
      readonly type: MediaType;
      readonly url: string;
    } | null;
    readonly notification: {
      readonly body: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"NotificationTableRow_notification">;
    } | null;
    readonly publishedAt: any;
  };
};
export type HighlightManageFormUpdateMutation = {
  response: HighlightManageFormUpdateMutation$data;
  variables: HighlightManageFormUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "caption",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archivedAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destinationUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverImageUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLHighlightAlbum",
  "kind": "LinkedField",
  "name": "highlightAlbum",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archivedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLMedia",
  "kind": "LinkedField",
  "name": "media",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isProcessing",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v12 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HighlightManageFormUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLHighlight",
        "kind": "LinkedField",
        "name": "updateHighlight",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLNotification",
            "kind": "LinkedField",
            "name": "notification",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NotificationTableRow_notification"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HighlightManageFormUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLHighlight",
        "kind": "LinkedField",
        "name": "updateHighlight",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLNotification",
            "kind": "LinkedField",
            "name": "notification",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audienceLanguages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "automaticArchiveTimestamp",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "confirmationStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbnailUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalThumbnailUri",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isArchived",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "landingPath",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timestamp",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "utmCampaign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLCDPAudience",
                "kind": "LinkedField",
                "name": "audiences",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "audienceName",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLDailyDeal",
                "kind": "LinkedField",
                "name": "dailyDeal",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLFeedPost",
                "kind": "LinkedField",
                "name": "feedPost",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLHighlight",
                "kind": "LinkedField",
                "name": "highlight",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLHighlightAlbum",
                    "kind": "LinkedField",
                    "name": "highlightAlbum",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "44d2f767712a4c2755d4d8fdf3b92a85",
    "id": null,
    "metadata": {},
    "name": "HighlightManageFormUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation HighlightManageFormUpdateMutation(\n  $input: GraphQLHighlightInputPartial!\n) {\n  updateHighlight(input: $input) {\n    id\n    caption\n    archivedAt\n    publishedAt\n    destinationUrl\n    highlightAlbum {\n      id\n      archivedCount\n      count\n      coverImageUrl\n    }\n    media {\n      type\n      url\n      coverImageUrl\n      isProcessing\n    }\n    notification {\n      title\n      body\n      ...NotificationTableRow_notification\n      id\n    }\n  }\n}\n\nfragment NotificationTableRow_notification on GraphQLNotification {\n  id\n  uuid\n  audienceLanguages\n  automaticArchiveTimestamp\n  body\n  confirmationStatus\n  thumbnailUrl\n  externalThumbnailUri\n  isArchived\n  landingPath\n  timestamp\n  title\n  utmCampaign\n  audiences {\n    audienceName\n    id\n  }\n  dailyDeal {\n    id\n  }\n  feedPost {\n    id\n  }\n  highlight {\n    id\n    highlightAlbum {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2db2868b55e3f319c22017407e4a9d67";

export default node;
